const Presets = [
    {
        image:"placeholder.png",
        date:"Monday 11:00 - 12:00",
        info:"This is a test description for an event",
        button:"Join",
        link:"https://member-dashboard.findabusinessexpert.com",
        shortitem:"Placeholder",
    },
    {
        image:"engagementgroup-jan2025.png",
        date:"Thursday 11:00 - 11:30",
        info:"A great opportunity now available on Thursday every week. Increase your reach with guaranteed engagement on the world's leading business networking platform",
        button:"Register",
        link:"https://member-dashboard.findabusinessexpert.com/engagement-pods",
        shortitem:"Engagement Pod",
    },
    {
        image:"businessgrowth-jan2025.png",
        date:"Thursday 10:00 - 11:00",
        info:"A unique opportunity to connect with peers, share proven strategies, receive feedback, and commit to actionable steps that enhance your business and personal wellbeing.",
        button:"Join Zoom Room",
        link:"https://us02web.zoom.us/my/bbsid",
        shortitem:"Business Growth",
    },
    {
        image:"speednetworking-jan2025.png",
        date:"Thursday 10:00 - 11:00",
        info:"This takes place on Blitzr, which transforms speed networking by creating virtual 1-on-1’s that are every bit as powerful as in-person events.",
        button:"Register",
        link:"https://blitzr.com/event/CHANGE/14436",
        shortitem:"Speed Networking",
    },
    {
        image:"maxyourmembershipfabe.jpeg",
        date:"Friday 15:00 - 15:45",
        info:"Learn about the key FaBE benefits and how you can use them to get max value from your membership.",
        button:"Join Zoom Room",
        link:"https://us02web.zoom.us/my/bbsid",
        shortitem:"Max Your Membership",
    }
   ]

export default Presets;